var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7784 21.1925C2.38787 20.8019 2.38787 20.1688 2.7784 19.7782L19.749 2.80768C20.1395 2.41716 20.7726 2.41716 21.1632 2.80768C21.5537 3.19821 21.5537 3.83137 21.1632 4.2219L4.19261 21.1925C3.80209 21.583 3.16892 21.583 2.7784 21.1925Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77824 2.80769C3.16877 2.41717 3.80193 2.41717 4.19246 2.80769L21.163 19.7783C21.5535 20.1688 21.5535 20.8019 21.163 21.1925C20.7725 21.583 20.1393 21.583 19.7488 21.1925L2.77824 4.22191C2.38772 3.83138 2.38772 3.19822 2.77824 2.80769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCross);
export default __webpack_public_path__ + "static/media/menu-cross.14ed534c8bcab4c5d8fffa60f9333113.svg";
export { ForwardRef as ReactComponent };